var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsSprite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-board-fourCircles-1",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4.396 6.978c0.301-1.281 1.301-2.282 2.582-2.582v0c1.11-0.26 2.266-0.26 3.377 0v0c1.281 0.301 2.282 1.301 2.582 2.582v0c0.26 1.11 0.26 2.266 0 3.377v0c-0.301 1.281-1.301 2.282-2.582 2.582v0c-1.11 0.26-2.266 0.26-3.377 0v0c-1.281-0.301-2.282-1.301-2.582-2.582v0c-0.26-1.11-0.26-2.266 0-3.377v0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4.396 21.645c0.301-1.281 1.301-2.282 2.582-2.582v0c1.11-0.261 2.266-0.261 3.377 0v0c1.281 0.3 2.282 1.301 2.582 2.582v0c0.26 1.111 0.26 2.266 0 3.377v0c-0.301 1.281-1.301 2.282-2.582 2.582v0c-1.11 0.261-2.266 0.261-3.377 0v0c-1.281-0.3-2.282-1.301-2.582-2.582v0c-0.26-1.111-0.26-2.266 0-3.377v0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M19.063 6.978c0.3-1.281 1.301-2.282 2.582-2.582v0c1.111-0.26 2.266-0.26 3.377 0v0c1.281 0.301 2.282 1.301 2.582 2.582v0c0.261 1.11 0.261 2.266 0 3.377v0c-0.3 1.281-1.301 2.282-2.582 2.582v0c-1.111 0.26-2.266 0.26-3.377 0v0c-1.281-0.301-2.282-1.301-2.582-2.582v0c-0.261-1.11-0.261-2.266 0-3.377v0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M19.063 21.645c0.3-1.281 1.301-2.282 2.582-2.582v0c1.111-0.261 2.266-0.261 3.377 0v0c1.281 0.3 2.282 1.301 2.582 2.582v0c0.261 1.111 0.261 2.266 0 3.377v0c-0.3 1.281-1.301 2.282-2.582 2.582v0c-1.111 0.261-2.266 0.261-3.377 0v0c-1.281-0.3-2.282-1.301-2.582-2.582v0c-0.261-1.111-0.261-2.266 0-3.377v0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-board-star-2",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 2.667l2.683 6.975c0.376 0.978 0.564 1.466 0.856 1.878 0.259 0.364 0.577 0.683 0.942 0.942 0.411 0.292 0.9 0.48 1.878 0.856l6.975 2.683-6.975 2.683c-0.978 0.376-1.466 0.564-1.878 0.856-0.364 0.259-0.683 0.577-0.942 0.942-0.292 0.411-0.48 0.9-0.856 1.878l-2.683 6.975-2.683-6.975c-0.376-0.978-0.564-1.466-0.856-1.878-0.259-0.364-0.578-0.683-0.942-0.942-0.411-0.292-0.9-0.48-1.878-0.856l-6.975-2.683 6.975-2.683c0.978-0.376 1.466-0.564 1.878-0.856 0.364-0.259 0.683-0.578 0.942-0.942 0.292-0.411 0.48-0.9 0.856-1.878l2.683-6.975z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-board-loading-3",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4.454 22.666c-1.67-2.893-0.821-6.58 1.944-8.453l0.003-0.003c2.221-1.501 5.143-1.45 7.312 0.126l4.576 3.327c2.167 1.576 5.090 1.627 7.312 0.126l0.003-0.003c2.766-1.872 3.616-5.563 1.943-8.453M22.669 27.546c-2.893 1.669-6.58 0.821-8.453-1.944l-0.003-0.003c-1.501-2.221-1.45-5.143 0.126-7.312l3.327-4.576c1.576-2.167 1.627-5.090 0.126-7.312l-0.006-0.003c-1.872-2.763-5.563-3.615-8.453-1.942M25.427 6.572c5.207 5.207 5.207 13.648 0 18.855s-13.648 5.207-18.855 0c-5.207-5.207-5.207-13.648 0-18.855s13.648-5.207 18.855 0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-board-puzzle-4",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 2.667l4.8 4.8c3.2-8.4 12.133 0.533 3.733 3.733l4.8 4.8-4.8 4.8c-3.2-8.4-12.133 0.533-3.733 3.733l-4.8 4.8-4.8-4.8c-3.2 8.4-12.133-0.533-3.733-3.733l-4.8-4.8 4.8-4.8c3.2 8.4 12.133-0.533 3.733-3.733l4.8-4.8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-board-box-5",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M27.333 9.704l-11.333 6.296M16 16l-11.333-6.296M16 16l0 12.667M28 21.411v-10.823c0-0.457 0-0.685-0.067-0.889-0.060-0.18-0.157-0.346-0.285-0.485-0.145-0.158-0.345-0.269-0.744-0.491l-9.867-5.481c-0.378-0.21-0.567-0.315-0.767-0.356-0.177-0.036-0.36-0.036-0.537 0-0.2 0.041-0.389 0.146-0.767 0.356l-9.867 5.481c-0.399 0.222-0.599 0.333-0.744 0.491-0.129 0.14-0.226 0.305-0.286 0.485-0.067 0.204-0.067 0.432-0.067 0.889v10.823c0 0.457 0 0.685 0.067 0.889 0.060 0.18 0.157 0.346 0.286 0.485 0.145 0.158 0.345 0.269 0.744 0.491l9.867 5.482c0.378 0.21 0.567 0.315 0.767 0.356 0.177 0.036 0.36 0.036 0.537 0 0.2-0.041 0.389-0.146 0.767-0.356l9.867-5.482c0.399-0.222 0.599-0.333 0.744-0.491 0.129-0.14 0.226-0.305 0.285-0.485 0.067-0.204 0.067-0.432 0.067-0.889z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-board-lightning-6",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M18.999 2.667h-7.674c-0.239 0-0.359 0-0.465 0.036-0.093 0.032-0.178 0.085-0.249 0.154-0.080 0.078-0.133 0.185-0.24 0.399l-5.6 11.2c-0.256 0.511-0.383 0.767-0.353 0.974 0.027 0.181 0.127 0.344 0.277 0.449 0.172 0.12 0.458 0.12 1.029 0.12h8.274l-4 13.333 16.258-16.86c0.548-0.569 0.823-0.853 0.839-1.097 0.014-0.211-0.073-0.417-0.235-0.553-0.186-0.157-0.581-0.157-1.372-0.157h-9.49l3-8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-board-colors-7",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 27.296c1.415 1.267 3.284 2.037 5.333 2.037 4.418 0 8-3.582 8-8 0-3.689-2.497-6.795-5.893-7.72M8.56 13.614c-3.396 0.925-5.894 4.031-5.894 7.72 0 4.418 3.582 8 8 8s8-3.582 8-8c0-1.041-0.199-2.035-0.56-2.947M24 10.667c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8c4.418 0 8 3.582 8 8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-board-hexagon-8",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M14.964 3.242c0.378-0.21 0.567-0.315 0.767-0.356 0.177-0.036 0.36-0.036 0.537 0 0.2 0.041 0.389 0.146 0.767 0.356l9.867 5.482c0.399 0.222 0.599 0.333 0.744 0.491 0.129 0.14 0.226 0.305 0.285 0.485 0.067 0.204 0.067 0.432 0.067 0.889v10.823c0 0.457 0 0.685-0.067 0.889-0.060 0.18-0.157 0.346-0.285 0.485-0.145 0.158-0.345 0.269-0.744 0.491l-9.867 5.482c-0.378 0.21-0.567 0.315-0.767 0.356-0.177 0.036-0.36 0.036-0.537 0-0.2-0.041-0.389-0.146-0.767-0.356l-9.867-5.482c-0.399-0.222-0.599-0.333-0.744-0.491-0.129-0.14-0.226-0.305-0.286-0.485-0.067-0.204-0.067-0.432-0.067-0.889v-10.823c0-0.457 0-0.685 0.067-0.889 0.060-0.18 0.157-0.346 0.286-0.485 0.145-0.158 0.345-0.269 0.744-0.491l9.867-5.481z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-default-bg",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--default-icon-stroke)",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M25.333 28h1.347c1.295 0 1.942 0 2.299-0.27 0.311-0.235 0.503-0.595 0.526-0.984 0.027-0.447-0.332-0.985-1.051-2.063l-4.014-6.021c-0.594-0.89-0.89-1.335-1.264-1.49-0.327-0.136-0.694-0.136-1.021 0-0.374 0.155-0.671 0.6-1.264 1.49l-0.992 1.488M25.333 28l-10.246-14.8c-0.589-0.851-0.884-1.277-1.252-1.426-0.322-0.131-0.682-0.131-1.004 0-0.368 0.15-0.663 0.575-1.252 1.426l-7.928 11.452c-0.751 1.084-1.126 1.626-1.105 2.077 0.019 0.393 0.21 0.757 0.522 0.996 0.359 0.274 1.018 0.274 2.337 0.274h19.928zM28 8c0 2.209-1.791 4-4 4s-4-1.791-4-4c0-2.209 1.791-4 4-4s4 1.791 4 4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSprite);
export default __webpack_public_path__ + "static/media/icons-sprite.f7bad1557d5f1ff811b95faf64f78ba8.svg";
export { ForwardRef as ReactComponent };